import { FC, useState, useEffect, useRef } from "react";
import Modal from "../shared/Modal/Modal";
import { useApp } from "../../context/AppContext";
import styles from "../../assets/css/preview.module.scss";
import { getMetafieldValue } from "../../services/shopify-storefront-api";
import { formatPrice } from "../../services/shopify-api";
import { trackPreviewFormField, trackCompareMaterialsEngagement } from "../../services/google_analytics";
import { useSearchParams } from "react-router-dom";
import { FoamPackage } from "../../types/shopify";

const FoamPackageSelectorMain: FC = () => {
  const { productData, selectedFoamPackageOption, setSelectedFoamPackageOption } = useApp();
  const [isCompareMaterialsOpen, setIsCompareMaterialsOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current && productData) {
      isInitialMount.current = false;
      const selectedFoamPackageFromQuery = searchParams.get('selected_foam_package');
      const variantIdFromQuery = searchParams.get('variant_id');
      if (selectedFoamPackageFromQuery || variantIdFromQuery) {
        trackPreviewFormField('foam_package', selectedFoamPackageOption, 'query_param');
      } else {
        trackPreviewFormField('foam_package', selectedFoamPackageOption, 'default');
      }
    }
  }, [productData, selectedFoamPackageOption, searchParams]);

  if (!productData) {
    return null;
  }

  const { foamPackages } = productData;

  const handleFoamPackageSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const foamPackageName = event.target.value;
    setSelectedFoamPackageOption(foamPackageName);
    trackPreviewFormField('foam_package', foamPackageName, 'user_selected');
  };

  const renderFoamPackage = (foamPackage: FoamPackage) => {
    const { name, price, currency, imageSrc, imageAlt } = foamPackage;

    return (
      <div key={name} className={`${styles.foamPackageSelectorItem} ${name === selectedFoamPackageOption ? styles.active : ""}`}>
        <input type="radio" id={name} name="foamPackage" value={name} checked={name === selectedFoamPackageOption} onChange={handleFoamPackageSelect} />
        <label htmlFor={name}>
          <div className={styles.foamPackageSelectorItemImgBox}>
            <img src={imageSrc} alt={imageAlt} />
          </div>
          <div className={styles.foamPackageSelectorItemName}>{name}</div>
          <div className={styles.foamPackageSelectorItemPrice}>{formatPrice(price, currency)}</div>
        </label>
      </div>
    );
  };

  const renderCompareMaterials = () => {

    return (
      <>
        <div>
          <button
            className={styles.compareMaterialsButton}
            onClick={() => {
              setIsCompareMaterialsOpen(!isCompareMaterialsOpen);
              document.body.classList.toggle(styles.compareMaterialsModalOpen);
              if (!isCompareMaterialsOpen) {
                trackCompareMaterialsEngagement();
              }
            }}
          >
            <i className="icon-info-o"></i> <span>Compare Materials</span>
          </button>
        </div>
        <Modal isOpen={isCompareMaterialsOpen}>
          <div className={styles.compareMaterialModal}>
            <div className={styles.compareMaterialOverlay}>&nbsp;</div>
            <div className={styles.compareMaterialModalContent}>
              <div className={styles.compareMaterialModalBody}>
                <div className={styles.compareMaterialModalHeader}>
                  Compare Materials
                </div>
                <div className={styles.compareMaterialItemRow}>
                  {foamPackages.map((foamPackage) => {
                    const { variant, price, currency, imageSrc, imageAlt } = foamPackage;
                    const materialTitle = getMetafieldValue(variant?.metafields, 'custom', 'material_title');

                    return (
                      <div key={foamPackage.name} className={styles.compareMaterialItem}>
                        <div className={styles.compareMaterialImgBox}>
                          <img
                            src={imageSrc}
                            alt={imageAlt}
                          />
                        </div>
                        <div className={styles.compareMaterialName}>
                          <span dangerouslySetInnerHTML={{ __html: materialTitle }} /> ({formatPrice(price, currency)})
                        </div>
                        {/* <div className={styles.compareMaterialSpecs}>
                            4.5mm thick
                            </div>
                          <div className={styles.compareMaterialSpecs}>
                            Best for tight to moderate fitting shoes
                          </div> */}
                        <div className={styles.compareMaterialDescription}>
                          {getMetafieldValue(variant?.metafields, 'custom', 'material_description')}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className={styles.compareMaterialModalCloseButton}>
                <button
                  className={styles.commonCloseButton}
                  onClick={() => {
                    setIsCompareMaterialsOpen(false);
                    document.body.classList.toggle(styles.compareMaterialsModalOpen);
                  }}
                >
                &nbsp;
              </button>

              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  };

  return (
    <div>
      <div className={styles.foamPackageSelector}>
        {foamPackages.map((foamPackage) => (
          renderFoamPackage(foamPackage)
        ))}
      </div>
      <div className={styles.compareMaterialsButtonContainer}>
        {renderCompareMaterials()}
      </div>
    </div>
  );
};

export default FoamPackageSelectorMain;
